import React, { useState, useEffect } from 'react';
import { CardSubtitle } from 'reactstrap';
import formatPhone from '~/utils/format/phone';
import { authorizedPyPublicInstance as py } from '~/utils';
import { useParams } from 'react-router-dom';
import { useFetch, Table } from '@cordata/buffet';

const PublicChildrensServiceAgency = () => {
  const params = useParams();

  const [, sourceCaseData] = useFetch(
    'data/public/list-view-cs-tbl-source-case',
    {
      params: {
        patient_uid: params.patient_id,
        sort: '-open_date_dt',
      },
      initialState: [],
      instance: 'p',
    },
  );
  const [pcsaData, setPcsaData] = useState([]);

  const [countyName, setCountyName] = useState('Loading...');
  const [countyPhone, setCountyPhone] = useState('Loading...');
  const [emergencyPhone, setEmergencyPhone] = useState('Loading...');

  useEffect(() => {
    if (sourceCaseData && sourceCaseData.length) {
      // hack to turn 3 tables into 1
      const roles = ['Case Worker', 'Supervisor', 'Section Chief'];
      const newData = [];

      roles.forEach((role) => {
        newData.push({
          ...sourceCaseData[0].attributes,
          role,
        });
      });

      setPcsaData(newData);

      py.get('list_view_cs_tbl_identity_source', {
        params: {
          agency_id: sourceCaseData[0].attributes.custodyAgencyId,
        },
      })
        .then(r => r.data.data)
        .then((r) => {
          if (r.length) {
            setCountyName(r[0].attributes.sourceName);
            setCountyPhone(r[0].attributes.mainPhone);
            setEmergencyPhone(r[0].attributes.emergencyPhone);
          } else {
            setCountyName(`No data found for agency_id: ${sourceCaseData[0].attributes.custodyAgencyId}`);
            setCountyPhone(`No data found for agency_id: ${sourceCaseData[0].attributes.custodyAgencyId}`);
            setEmergencyPhone(`No data found for agency_id: ${sourceCaseData[0].attributes.custodyAgencyId}`);
          }

          return r;
        });
    }
  }, [sourceCaseData]);

  return (
    <React.Fragment>
      <CardSubtitle tag="h5" className="m-2">
        County: {countyName}
      </CardSubtitle>

      <h6 className="mx-4"><a href={`tel:${countyPhone}`}>{formatPhone(countyPhone)}</a></h6>

      <CardSubtitle tag="h5" className="m-2">
        Contacts
      </CardSubtitle>

      <Table
        className="mx-4"
        filterable={false}
        data={pcsaData}
        showPaginationBottom={false}
        columns={[
          {
            id: 'role',
            Header: 'Role',
            accessor: 'role',
          },
          {
            id: 'name',
            Header: 'Name',
            accessor: (row) => {
              if (row.role === 'Case Worker') {
                return row.wkrName;
              } else if (row.role === 'Supervisor') {
                return row.supName;
              }
              return row.chfName;
            },
          },
          {
            id: 'phone',
            Header: 'Phone',
            accessor: (row) => {
              if (row.role === 'Case Worker') {
                return (
                  <>
                    <a href={`tel:${row.wkrPhone}`}>
                      {formatPhone(row.wkrPhone)}
                    </a>
                  </>
                );
              } else if (row.role === 'Supervisor') {
                return (
                  <>
                    <a href={`tel:${row.supPhone}`}>
                      {formatPhone(row.supPhone)}
                    </a>
                  </>
                );
              }
              return (
                <>
                  <a href={`tel:${row.chfPhone}`}>
                    {formatPhone(row.chfPhone)}
                  </a>
                </>
              );
            },
            cellType: 'tel',
          },
          {
            id: 'email',
            Header: 'Email',
            accessor: (row) => {
              let email = '';

              if (row.role === 'Case Worker') {
                email = row.wkrEmail;
              } else if (row.role === 'Supervisor') {
                email = row.supEmail;
              } else {
                email = row.chfEmail;
              }

              return <a href={`mailto:${email}`}>{email}</a>;
            },
          },
        ]}
        minRows={pcsaData.length === 0 && 2}
      />

      <CardSubtitle tag="h5" className="m-2">
        After Hours Emergency
      </CardSubtitle>

      <h6 className="mx-4"><a href={`tel:${emergencyPhone}`}>{formatPhone(emergencyPhone)}</a></h6>
    </React.Fragment>
  );
};

export default PublicChildrensServiceAgency;
